import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BadgeType } from 'src/app/model/badge-type-enum';
import { BADGE_TYPE_ICON_MAP } from 'src/app/model/badge-type-icon-map';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  readonly type = input<BadgeType>(BadgeType.NEUTRAL);
  readonly translationKey = input.required<string>();

  readonly icon = computed(() => BADGE_TYPE_ICON_MAP[this.type()]);
}
